// D6 — one-question conversion micro-survey shown to users who haven't issued.
// Captures WHY they're stalled (→ a feedback ticket the admin sees). Compact:
// a link that expands to the options.
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { api } from '../api/client';

const REASONS = ['not_sure_how', 'missing_feature', 'too_expensive', 'just_exploring', 'no_time', 'other'] as const;

export function ConversionSurvey() {
  const { t } = useTranslation('dashboard');
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState<string>('');
  const [text, setText] = useState('');
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  if (done) return <p className="mt-4 text-sm text-primary-800">{t('survey.thanks')}</p>;

  if (!open) {
    return (
      <button type="button" onClick={() => setOpen(true)} className="mt-4 text-sm font-medium text-primary-700 hover:underline">
        {t('survey.prompt')}
      </button>
    );
  }

  const submit = async () => {
    if (!reason) return;
    setBusy(true);
    try { await api.submitSurvey(reason, text); setDone(true); }
    catch { setDone(true); /* fail quietly — feedback is best-effort */ }
    finally { setBusy(false); }
  };

  return (
    <div className="mt-4 rounded-lg border border-primary-200 bg-white p-4">
      <p className="text-sm font-medium text-gray-800">{t('survey.question')}</p>
      <div className="mt-2 space-y-1.5">
        {REASONS.map(r => (
          <label key={r} className="flex items-center gap-2 text-sm text-gray-700">
            <input type="radio" name="survey-reason" value={r} checked={reason === r} onChange={() => setReason(r)} />
            {t(`survey.reasons.${r}`)}
          </label>
        ))}
      </div>
      <textarea
        value={text}
        onChange={e => setText(e.target.value)}
        placeholder={t('survey.placeholder')}
        rows={2}
        className="mt-3 w-full rounded border border-gray-300 px-3 py-2 text-sm"
      />
      <div className="mt-3 flex gap-2">
        <button type="button" onClick={submit} disabled={!reason || busy}
          className="rounded-md bg-primary-600 px-4 py-1.5 text-sm font-semibold text-white hover:bg-primary-700 disabled:opacity-50">
          {busy ? t('survey.sending') : t('survey.submit')}
        </button>
        <button type="button" onClick={() => setOpen(false)} className="rounded-md px-3 py-1.5 text-sm text-gray-500 hover:bg-gray-100">
          {t('survey.cancel')}
        </button>
      </div>
    </div>
  );
}
